import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@upme/ui/components/button';
import { CitiesTable } from '../../../features/cities/components/cities-table';
import { listCitiesOptions } from '../../../features/cities/queries';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/cities/')({
  loader: ({ context }) => context.queryClient.ensureQueryData(listCitiesOptions()),
  component: CitiesIndexPage,
});

function CitiesIndexPage() {
  const { data: cities } = useSuspenseQuery(listCitiesOptions());
  return (
    <div>
      <PageHeader
        title="Города"
        description="Управление городами платформы"
        actions={
          <Button asChild>
            <Link to="/cities/new">Новый город</Link>
          </Button>
        }
      />
      <CitiesTable cities={cities} />
    </div>
  );
}
